import axios from "axios"
import { toast } from "react-toastify"
import { UrlApi } from "../Keys"
import moment from "moment/moment"

let loadingToast = null

const ToastLoading = (msj) => {
  loadingToast = toast.info(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  })
}

const ToastSuccess = (msj) => {
  toast.success(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}

const ToastError = (msj) => {
  toast.error(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}

const dataInicial = {
  tipoLicencia: [],
  getLicencia: false,
  licenciasIngresadas: [],
  misSolicitudesAprobadas: [],
  getLicenciaAprobadas: false,
  misSolicitudesNoAdmitidas: [],
  getLicenciaNoAprobadas: false,
  ingresadasEquipo: [],
  getEquipoIngresadas: false,
  aprobadasXmiEquipo: [],
  getEquipoAprobadas: false,
  noAdmitidasEquipo: [],
  getEquipoNoAdmitidas: false,
  cargaDocumento: "",
  loadCargaLicencia: "",
  loadAprobarRechazarLicencia: "",
  loadEnviarMasInformacion: "",
}

const LOADING_TIPO_LICENCIA = "LOADING_TIPO_LICENCIA"
const TIPO_LICENCIA = "TIPO_LICENCIA"
const TIPO_LICENCIA_ERROR = "TIPO_LICENCIA_ERROR"

const LOADING_INGRESADAS = "LOADING_INGRESADAS"
const INGRESADAS = "INGRESADAS"
const ERROR_INGRESADAS = "ERROR_INGRESADAS"

const LOADING_MIS_SOLICITUDES_APROBADAS = "LOADING_MIS_SOLICITUDES_APROBADAS"
const MIS_SOLICITUDES_APROBADAS = "MIS_SOLICITUDES_APROBADAS"
const ERROR_MIS_SOLICITUDES_APROBADAS = "ERROR_MIS_SOLICITUDES_APROBADAS"

const LOADING_SOLICITUDES_NO_ADMITIDAS = "LOADING_SOLICITUDES_NO_ADMITIDAS"
const MIS_SOLICITUDES_NO_ADMITIDAS = "MIS_SOLICITUDES_NO_ADMITIDAS"
const ERROR_MIS_SOLICITUDES_NO_ADMITIDAS = "ERROR_MIS_SOLICITUDES_NO_ADMITIDAS"

const LOADING_EQUIPO_I = "LOADING_EQUIPO_I"
const EQUIPO_INGRESADAS = "EQUIPO_INGRESADAS"
const ERROR_EQUIPO_ING = "ERROR_EQUIPO_ING"

const LOADING_EQUIPO_A = "LOADING_EQUIPO_A"
const EQUIPO_APROBADAS = "EQUIPO_APROBADAS"
const ERROR_EQUIPO_APB = "ERROR_EQUIPO_APB"

const LOADING_EQUIPO_NO_ADMITIDAS = "LOADING_EQUIPO_NO_ADMITIDAS"
const EQUIPO_NO_ADMITIDAS = "EQUIPO_NO_ADMITIDAS"
const ERROR_EQUIPO_NO_ADMITIDAS = "ERROR_EQUIPO_NO_ADMITIDAS"

const LOADING_NUEVA_SOLICITUD_LICENCIA = "LOADING_NUEVA_SOLICITUD_LICENCIA"
const EXITO_NUEVA_SOLICITUD_LICENCIA = "EXITO_NUEVA_SOLICITUD_LICENCIA"
const ERROR_NUEVA_SOLICITUD_LICENCIA = "LOADING_NUEVA_SOLICITUD_LICENCIA"

const LOADING_APROBAR_RECHAZAR_LICENCIA = "LOADING_APROBAR_RECHAZAR_LICENCIA"
const EXITO_APROBAR_RECHAZAR_LICENCIA = "EXITO_APROBAR_RECHAZAR_LICENCIA"
const ERROR_APROBAR_RECHAZAR_LICENCIA = "ERROR_APROBAR_RECHAZAR_LICENCIA"

const LOADING_SET_MAS_INFORMACION_LICENCIA = "LOADING_SET_MAS_INFORMACION_LICENCIA"
const EXITO_SET_MAS_INFORMACION_LICENCIA = "EXITO_SET_MAS_INFORMACION_LICENCIA"
const ERROR_SET_MAS_INFORMACION_LICENCIA = "ERROR_SET_MAS_INFORMACION_LICENCIA"

//Reducers
export default function licenciasReducer(state = dataInicial, action) {
  switch (action.type) {
    case TIPO_LICENCIA:
      return { ...state, tipoLicencia: action.payload }
    case LOADING_INGRESADAS:
      return { ...state, getLicencia: action.getLicencia }
    case INGRESADAS:
      return { ...state, licenciasIngresadas: action.payload, getLicencia: action.getLicencia }
    case ERROR_INGRESADAS:
      return { ...state, getLicencia: action.getLicencia }
    case LOADING_MIS_SOLICITUDES_APROBADAS:
      return { ...state, getLicenciaAprobadas: action.getLicenciaAprobadas }
    case MIS_SOLICITUDES_APROBADAS:
      return { ...state, misSolicitudesAprobadas: action.payload, getLicenciaAprobadas: action.getLicenciaAprobadas }
    case ERROR_MIS_SOLICITUDES_APROBADAS:
      return { ...state, getLicenciaAprobadas: action.getLicenciaAprobadas }
    case LOADING_SOLICITUDES_NO_ADMITIDAS:
      return { ...state, getLicenciaNoAprobadas: action.getLicenciaNoAprobadas }
    case MIS_SOLICITUDES_NO_ADMITIDAS:
      return { ...state, misSolicitudesNoAdmitidas: action.payload, getLicenciaNoAprobadas: action.getLicenciaNoAprobadas }
    case ERROR_MIS_SOLICITUDES_NO_ADMITIDAS:
      return { ...state, getLicenciaNoAprobadas: action.getLicenciaNoAprobadas }
    case LOADING_EQUIPO_I:
      return { ...state, getEquipoIngresadas: action.getEquipoIngresadas }
    case EQUIPO_INGRESADAS:
      return { ...state, ingresadasEquipo: action.payload, getEquipoIngresadas: action.getEquipoIngresadas }
    case ERROR_EQUIPO_ING:
      return { ...state, getEquipoIngresadas: action.getEquipoIngresadas }
    case LOADING_EQUIPO_A:
      return { ...state, getEquipoAprobadas: action.getEquipoAprobadas }
    case EQUIPO_APROBADAS:
      return { ...state, aprobadasXmiEquipo: action.payload, getEquipoAprobadas: action.getEquipoAprobadas }
    case ERROR_EQUIPO_APB:
      return { ...state, getEquipoAprobadas: action.getEquipoAprobadas }
    case LOADING_EQUIPO_NO_ADMITIDAS:
      return { ...state, getEquipoNoAdmitidas: action.getEquipoNoAdmitidas }
    case EQUIPO_NO_ADMITIDAS:
      return { ...state, noAdmitidasEquipo: action.payload, getEquipoNoAdmitidas: action.getEquipoNoAdmitidas }
    case ERROR_EQUIPO_NO_ADMITIDAS:
      return { ...state, getEquipoNoAdmitidas: action.getEquipoNoAdmitidas }
    case LOADING_NUEVA_SOLICITUD_LICENCIA:
      return { ...state, loadCargaLicencia: action.resultado }
    case EXITO_NUEVA_SOLICITUD_LICENCIA:
      return { ...state, loadCargaLicencia: action.resultado }
    case ERROR_NUEVA_SOLICITUD_LICENCIA:
      return { ...state, loadCargaLicencia: action.resultado }
    case LOADING_APROBAR_RECHAZAR_LICENCIA:
      return { ...state, loadAprobarRechazarLicencia: action.resultado }
    case EXITO_APROBAR_RECHAZAR_LICENCIA:
      return { ...state, loadAprobarRechazarLicencia: action.resultado }
    case ERROR_APROBAR_RECHAZAR_LICENCIA:
      return { ...state, loadAprobarRechazarLicencia: action.resultado }
    case LOADING_SET_MAS_INFORMACION_LICENCIA:
      return { ...state, loadEnviarMasInformacion: action.resultado }
    case EXITO_SET_MAS_INFORMACION_LICENCIA:
      return { ...state, loadEnviarMasInformacion: action.resultado }
    case ERROR_SET_MAS_INFORMACION_LICENCIA:
      return { ...state, loadEnviarMasInformacion: action.resultado }
    default:
      return { ...state }
  }
}

export const tipoDeLicencias = (token) => async (dispatch) => {
  dispatch({
    type: LOADING_TIPO_LICENCIA,
  })

  try {
    var entidad = "new_tipodelicencias"
    var fetch =
      "<entity name='new_tipodelicencia'>" +
      "<attribute name='new_name'/>" +
      "<attribute name='new_tipodelicenciaid'/>" +
      "<order attribute='new_name' descending='false'/>" +
      "<filter type='and'>" +
      "<condition attribute='new_segmento' operator='ne' value='100000004'/>" +
      "</filter>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: TIPO_LICENCIA,
      payload: response.data,
    })
  } catch (error) {
    dispatch({
      type: TIPO_LICENCIA_ERROR,
    })
  }
}

export const ingresadas = (token, usuarioPortalRH) => async (dispatch) => {
  dispatch({
    type: LOADING_INGRESADAS,
    getLicencia: false,
  })

  try {
    var entidad = "new_licencias"
    var fetch =
      "<entity name='new_licencia'>" +
      "<attribute name='new_licenciaid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_empleado' />" +
      "<attribute name='createdon' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='new_fechahasta' />" +
      "<attribute name='new_fechadesde' />" +
      "<attribute name='new_fechadesolicitud' />" +
      "<attribute name='new_diassolicitados' />" +
      "<order attribute='createdon' descending='true' />" +
      "<filter type='and'>" +
      "<filter type='or'>" +
      "<filter type='or'>" +
      "<filter type='and'>" +
      "<condition attribute='createdon' operator='last-x-months' value='3' />" +
      "<condition attribute='statuscode' operator='eq' value='100000000' />" +
      "<condition attribute='new_validacion1' operator='null' />" +
      "<condition attribute='new_validacion2' operator='null' />" +
      "<condition attribute='new_validacion3' operator='null' />" +
      "<condition attribute='new_validacion4' operator='null' />" +
      "</filter>" +
      "<condition attribute='statuscode' operator='eq' value='1' />" +
      "</filter>" +
      "<condition attribute='statuscode' operator='eq' value='100000005' />" +
      "</filter>" +
      "</filter>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='ad'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='eq' value='" +
      usuarioPortalRH +
      "' />" +
      "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_tipodelicencia' from='new_tipodelicenciaid' to='new_tipodelicencia' link-type='inner' alias='ab'>" +
      "<filter type='and'>" +
      "<condition attribute='new_segmento' operator='ne' value='100000004' />" +
      "</filter>" +
      "</link-entity>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: INGRESADAS,
      payload: response.data,
      getLicencia: true,
    })
  } catch (error) {
    dispatch({
      type: ERROR_INGRESADAS,
      getLicencia: true,
    })
  }
}

export const misSolicitudesAprobadas = (token, usuarioPortalRH) => async (dispatch) => {
  dispatch({
    type: LOADING_MIS_SOLICITUDES_APROBADAS,
    getLicenciaAprobadas: false,
  })

  try {
    var entidad = "new_licencias"
    var fetch =
      "<entity name='new_licencia'>" +
      "<attribute name='new_licenciaid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_empleado' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_fechahasta' />" +
      "<attribute name='new_fechadesde' />" +
      "<attribute name='new_fechadesolicitud' />" +
      "<attribute name='new_diassolicitados' />" +
      "<order attribute='createdon' descending='true' />" +
      "<filter type='and'>" +
      // "<condition attribute='createdon' operator='last-x-months' value='3' />" +
      "<condition attribute='statuscode' operator='eq' value='100000000' />" +
      "</filter>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='ad'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='eq' value='" +
      usuarioPortalRH +
      "' />" +
      "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_tipodelicencia' from='new_tipodelicenciaid' to='new_tipodelicencia' link-type='inner' alias='ax'>" +
      "<filter type='and'>" +
      "<condition attribute='new_segmento' operator='ne' value='100000004' />" +
      "</filter>" +
      "</link-entity>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: MIS_SOLICITUDES_APROBADAS,
      payload: response.data,
      getLicenciaAprobadas: true,
    })
  } catch (error) {
    dispatch({
      type: ERROR_MIS_SOLICITUDES_APROBADAS,
      getLicenciaAprobadas: true,
    })
  }
}

export const misSolicitudesNoAdmitidas = (token, usuarioPortalRH) => async (dispatch) => {
  dispatch({
    type: LOADING_SOLICITUDES_NO_ADMITIDAS,
    getLicenciaNoAprobadas: false,
  })

  try {
    var entidad = "new_licencias"
    var fetch =
      "<entity name='new_licencia'>" +
      "<attribute name='new_licenciaid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_empleado' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_fechahasta' />" +
      "<attribute name='new_fechadesde' />" +
      "<attribute name='new_fechadesolicitud' />" +
      "<attribute name='new_diassolicitados' />" +
      "<order attribute='createdon' descending='true' />" +
      "<filter type='and'>" +
      "<condition attribute='new_empleadoportal' operator='eq' value='" +
      usuarioPortalRH +
      "' />" +
      "</filter>" +
      "<filter type='and'>" +
      "<condition attribute='statuscode' operator='eq' value='100000001' />" +
      "<condition attribute='new_licenciavalidada' operator='eq' value='0' />" +
      "</filter>" +
      "<link-entity name='new_tipodelicencia' from='new_tipodelicenciaid' to='new_tipodelicencia' link-type='inner' alias='ba'>" +
      "<filter type='and'>" +
      "<condition attribute='new_segmento' operator='ne' value='100000004' />" +
      "</filter>" +
      "</link-entity>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: MIS_SOLICITUDES_NO_ADMITIDAS,
      payload: response.data,
      getLicenciaNoAprobadas: true,
    })
  } catch (error) {
    dispatch({
      type: ERROR_MIS_SOLICITUDES_NO_ADMITIDAS,
      getLicenciaNoAprobadas: true,
    })
  }
}

export const equipoIngresadas = (token, usuarioPortalRH) => async (dispatch) => {
  dispatch({
    type: LOADING_EQUIPO_I,
    getEquipoIngresadas: false,
  })

  try {
    var entidad = "new_licencias"
    var fetch =
      "<entity name='new_licencia'>"+
      "<attribute name='new_name' />" +
      "<attribute name='new_fechahasta' />" +
      "<attribute name='new_fechadesde' />" +
      "<attribute name='new_fechadesolicitud' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_licenciaid' />" +
      "<attribute name='new_diassolicitados' />" +
      "<attribute name='new_validadorrecursoshumanos' />" +
      "<attribute name='new_validador1' />" +
      "<attribute name='new_aprobacionrecursoshumanos' />" +
      "<attribute name='new_validacion1' />" +
      "<attribute name='new_licenciaprolongada' />" +
      "<attribute name='new_comentarios' />" +
      "<attribute name='new_aprobador1' />" +
      "<attribute name='new_aprobacionsupervisor' />" +
      "<attribute name='new_empleado' />" +
      "<order attribute='createdon' descending='true' />"+
      "<filter type='and'>"+
        "<filter type='or'>"+
          "<filter type='and'>"+
            "<condition attribute='new_usuarioportalaprobador1' operator='like' value='" + usuarioPortalRH + "' />" +
            "<condition attribute='new_aprobacionsupervisor' operator='not-in'>"+
              "<value>100000000</value>"+
              "<value>100000001</value>"+
            "</condition>"+
          "</filter>"+
          "<filter type='and'>"+
            "<condition attribute='new_usuarioportalvalidador1' operator='like' value='" + usuarioPortalRH + "' />" +
            "<condition attribute='new_validacion1' operator='not-in'>"+
              "<value>100000000</value>"+
              "<value>100000001</value>"+
            "</condition>"+
          "</filter>"+
          "<filter type='and'>"+
            "<condition attribute='new_usuarioportalvalidador2' operator='like' value='" + usuarioPortalRH + "' />" +
            "<condition attribute='new_validacion2' operator='not-in'>"+
              "<value>100000000</value>"+
              "<value>100000001</value>"+
            "</condition>"+
          "</filter>"+
          "<filter type='and'>"+
            "<condition attribute='new_usuarioportalvalidador4' operator='like' value='" + usuarioPortalRH + "' />" +
            "<condition attribute='new_validacion4' operator='not-in'>"+
              "<value>100000000</value>"+
              "<value>100000001</value>"+
            "</condition>"+
          "</filter>"+
        "</filter>"+
      "</filter>"+
      "<link-entity name='new_tipodelicencia' from='new_tipodelicenciaid' to='new_tipodelicencia' link-type='inner' alias='ah'>"+
        "<filter type='and'>"+
          "<condition attribute='new_segmento' operator='ne' value='100000004' />"+
        "</filter>"+
      "</link-entity>"+
    "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: EQUIPO_INGRESADAS,
      payload: response.data,
      getEquipoIngresadas: true,
    })
  } catch (error) {
    dispatch({
      type: ERROR_EQUIPO_ING,
      getEquipoIngresadas: true,
    })
  }
}

export const equipoSolicitudesAprobadas = (token, usuarioPortalRH) => async (dispatch) => {
  dispatch({
    type: LOADING_EQUIPO_A,
    getEquipoAprobadas: false,
  })

  try {
    var entidad = "new_licencias"
    var fetch =
      "<entity name='new_licencia'>"+
      "<attribute name='new_name' />" +
      "<attribute name='new_fechahasta' />" +
      "<attribute name='new_fechadesde' />" +
      "<attribute name='new_fechadesolicitud' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_licenciaid' />" +
      "<attribute name='new_diassolicitados' />" +
      "<attribute name='new_validadorrecursoshumanos' />" +
      "<attribute name='new_validador1' />" +
      "<attribute name='new_aprobacionrecursoshumanos' />" +
      "<attribute name='new_validacion1' />" +
      "<attribute name='new_licenciaprolongada' />" +
      "<attribute name='new_comentarios' />" +
      "<attribute name='new_aprobador1' />" +
      "<attribute name='new_aprobacionsupervisor' />" +
      "<attribute name='new_empleado' />" +
      "<order attribute='createdon' descending='true' />"+
      "<filter type='or'>"+
        "<filter type='and'>"+
          "<condition attribute='createdon' operator='last-x-months' value='3' />"+
          "<condition attribute='new_usuarioportalaprobador1' operator='like' value='" + usuarioPortalRH + "' />" +
          "<condition attribute='new_aprobacionsupervisor' operator='eq' value='100000000' />"+
        "</filter>"+
        "<filter type='and'>"+
          "<condition attribute='new_usuarioportalvalidador1' operator='like' value='" + usuarioPortalRH + "' />" +
          "<condition attribute='new_validacion1' operator='eq' value='100000000' />"+
        "</filter>"+
        "<filter type='and'>"+
          "<condition attribute='new_usuarioportalvalidador2' operator='like' value='" + usuarioPortalRH + "' />" +
          "<condition attribute='new_validacion2' operator='eq' value='100000000' />"+
        "</filter>"+
        "<filter type='and'>"+
          "<condition attribute='new_usuarioportalvalidador4' operator='like' value='" + usuarioPortalRH + "' />" +
          "<condition attribute='new_validacion4' operator='eq' value='100000000' />"+
        "</filter>"+
      "</filter>"+
      "<link-entity name='new_tipodelicencia' from='new_tipodelicenciaid' to='new_tipodelicencia' link-type='inner' alias='bf'>"+
        "<filter type='and'>"+
          "<condition attribute='new_segmento' operator='ne' value='100000004' />"+
        "</filter>"+
      "</link-entity>"+
    "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: EQUIPO_APROBADAS,
      payload: response.data,
      getEquipoAprobadas: true,
    })
  } catch (error) {
    dispatch({
      type: ERROR_EQUIPO_APB,
      getEquipoAprobadas: true,
    })
  }
}

export const equipoNoAdmitidas = (token, usuarioPortalRH) => async (dispatch) => {
  dispatch({
    type: LOADING_EQUIPO_NO_ADMITIDAS,
    getEquipoNoAdmitidas: false,
  })

  try {
    var entidad = "new_licencias"
    var fetch =
      "<entity name='new_licencia'>" +
      "<attribute name='new_name' />" +
      "<attribute name='new_fechahasta' />" +
      "<attribute name='new_fechadesde' />" +
      "<attribute name='new_fechadesolicitud' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_licenciaid' />" +
      "<attribute name='new_diassolicitados' />" +
      "<attribute name='new_validadorrecursoshumanos' />" +
      "<attribute name='new_validador1' />" +
      "<attribute name='new_aprobacionrecursoshumanos' />" +
      "<attribute name='new_validacion1' />" +
      "<attribute name='new_licenciaprolongada' />" +
      "<attribute name='new_comentarios' />" +
      "<attribute name='new_aprobador1' />" +
      "<attribute name='new_aprobacionsupervisor' />" +
      "<attribute name='new_empleado' />" +
      "<order attribute='createdon' descending='true' />" +
      "<filter type='or'>" +
      "<filter type='and'>" +
      "<condition attribute='new_usuarioportalaprobador1' operator='like' value='" +
      usuarioPortalRH +
      "' />" +
      "<condition attribute='new_aprobacionsupervisor' operator='eq' value='100000001' />" +
      "</filter>" +
      "<filter type='and'>" +
      "<condition attribute='new_usuarioportalvalidador1' operator='like' value='" +
      usuarioPortalRH +
      "' />" +
      "<condition attribute='new_validacion1' operator='eq' value='100000001' />" +
      "</filter>" +
      "<filter type='and'>" +
      "<condition attribute='new_usuarioportalvalidador2' operator='like' value='" +
      usuarioPortalRH +
      "' />" +
      "<condition attribute='new_validacion2' operator='eq' value='100000001' />" +
      "</filter>" +
      "<filter type='and'>" +
      "<condition attribute='new_usuarioportalvalidador4' operator='like' value='" +
      usuarioPortalRH +
      "' />" +
      "<condition attribute='new_validacion4' operator='eq' value='100000001' />" +
      "</filter>" +
      "</filter>" +
      "<link-entity name='new_tipodelicencia' from='new_tipodelicenciaid' to='new_tipodelicencia' link-type='inner' alias='bh'>" +
      "<filter type='and'>" +
      "<condition attribute='new_segmento' operator='ne' value='100000004' />" +
      "</filter>" +
      "</link-entity>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: EQUIPO_NO_ADMITIDAS,
      payload: response.data,
      getEquipoNoAdmitidas: true,
    })
  } catch (error) {
    dispatch({
      type: ERROR_EQUIPO_NO_ADMITIDAS,
      getEquipoNoAdmitidas: true,
    })
  }
}


export const solicitudLicencia = (token, datos) => async (dispatch) => {
  dispatch({
    type: LOADING_NUEVA_SOLICITUD_LICENCIA,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")
  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios.post(`${UrlApi}api/hrfactors/solicitudlicencia`, 
        {
          "new_empleado": datos.empleado,
          "new_tipodelicencia": datos.tipoLicencia.value,
          "new_comentarios": datos.comentarios,
          "new_fechadesde": datos.fechaDesde ? moment(datos.fechaDesde).format('YYYY-MM-DD') : "",
          "new_diassolicitados": datos.cantidadDias ? Number(datos.cantidadDias) : 0
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          dispatch({
            type: EXITO_NUEVA_SOLICITUD_LICENCIA,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Licencia cargada con éxito");
          resolve(response.data); 
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: ERROR_NUEVA_SOLICITUD_LICENCIA,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    } 
  });
};

export const aprobarRechazarLicencia = (token, datos) => async (dispatch) => {
  dispatch({
    type: LOADING_APROBAR_RECHAZAR_LICENCIA,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")
  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios.put(`${UrlApi}api/hrfactors/aprobarrechazarlicencia`, 
        {
          "new_licenciaId": datos.id,
          "new_licenciaprolongada": datos.licenciaProlongada,
          "new_comentarios": datos.comentarios,
          "new_aprobador1": datos.idAprobador1,
          "new_aprobacionsupervisor": datos.aprobacion1 ? Number(datos.aprobacion1) : 0,
          "new_validador1": datos.idValidador1,
          "new_validacion1": datos.validacion1 ? Number(datos.validacion1) : 0,
          "new_validadorrecursoshumanos": datos.idValidadorRRHH,
          "new_aprobacion3": datos.validacion3 ? Number(datos.validacion3) : 0,
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          dispatch({
            type: EXITO_APROBAR_RECHAZAR_LICENCIA,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Licencia cargada con éxito");
          resolve(response.data); 
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: ERROR_APROBAR_RECHAZAR_LICENCIA,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    } 
  });
};

export const enviarMasInformacionLicencia = (token, datos) => async (dispatch) => {
  dispatch({
    type: LOADING_SET_MAS_INFORMACION_LICENCIA,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")
  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios.put(`${UrlApi}api/hrfactors/aprobarrechazarlicencia`, 
        {
          "new_licenciaId": datos.id,
          "new_comentarios": datos.comentarios,
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          dispatch({
            type: EXITO_SET_MAS_INFORMACION_LICENCIA,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Licencia actualizada con éxito");
          resolve(response.data); 
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: ERROR_SET_MAS_INFORMACION_LICENCIA,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    } 
  });
};